const PREFIX = "@HIGHGROUND_GLOBAL_";

export const MENU_COLLAPSE = `${PREFIX}COLLAPSE`;
